import apiService from './api.service';
import type { PublicProfileData, UserProfileData } from '@/types/profile';

class ProfileService {
  async getProfile(): Promise<UserProfileData> {
    const response = await apiService.get<UserProfileData>('/users/me/profile/');
    return response.data;
  }

  async getPublicProfile(userId: string): Promise<PublicProfileData> {
    const response = await apiService.get<PublicProfileData>(`/users/${userId}/public-profile/`);
    return response.data;
  }

  async updateProfilePublic(isPublic: boolean): Promise<void> {
    await apiService.patch('/auth/me/', { is_profile_public: isPublic });
  }

  async getNotificationPreferences(): Promise<Record<string, boolean>> {
    const response = await apiService.get<Record<string, boolean>>('/users/notification-preferences/');
    return response.data;
  }

  async updateNotificationPreferences(prefs: Record<string, boolean>): Promise<Record<string, boolean>> {
    const response = await apiService.patch<Record<string, boolean>>('/users/notification-preferences/', prefs);
    return response.data;
  }
}

export const profileService = new ProfileService();
